import { createSelector } from 'reselect'
import { AppState } from '@chegg-wt/core/state/types'

export const movedCitationsProjectNameSelector = (state: AppState): string | null =>
  state.movedCitations.projectName

export const movedCitationsProjectIdSelector = (state: AppState): string | null =>
  state.movedCitations.projectId

export const movedCitationsCountSelector = (state: AppState): number | null =>
  state.movedCitations.count

export const isMovedCitationsSuccessSelector = createSelector(
  [movedCitationsProjectNameSelector],
  (name): boolean => !!name
)
